import { MedicalOperator, MedicalOperatorDTO } from 'models/medicalOperator';

export enum ModalOperation {
  AssignPatients = 'ASSING_NEW_PATIENTS',
  AddNewPatient = 'ADD_NEW_PATIENT',
  ImportPatients = 'IMPORT_PATIENTS',
  ManagePatients = 'MANAGE_PATIENTS',
}
export interface MedicalOperatorPatientModalState {
  medicalOperator?: MedicalOperator;
  operationVisible?: ModalOperation;
}

export enum ModalActionType {
  Hide = 'HIDE',
  ShowAddNewPatient = 'SHOW_ADD_NEW_PATIENT',
  ShowAssignPatients = 'SHOW_ASSIGN_PATIENTS',
  ShowImportPatients = 'SHOW_IMPORT_PATIENTS',
  ShowPatientsManagement = 'SHOW_PATIENTS_MANAGEMENT',
}

type Action = {
  type: ModalActionType;
  medicalOperator?: MedicalOperatorDTO;
};

export const medicalOperatorsModalReducer = (
  state: MedicalOperatorPatientModalState,
  action: Action
) => {
  switch (action.type) {
    case ModalActionType.Hide:
      return {
        medicalOperator: undefined,
        operationVisible: undefined,
      };
    case ModalActionType.ShowAddNewPatient:
      return {
        medicalOperator: action.medicalOperator,
        operationVisible: ModalOperation.AddNewPatient,
      };
    case ModalActionType.ShowAssignPatients:
      return {
        medicalOperator: action.medicalOperator,
        operationVisible: ModalOperation.AssignPatients,
      };
    case ModalActionType.ShowImportPatients:
      return {
        medicalOperator: action.medicalOperator,
        operationVisible: ModalOperation.ImportPatients,
      };
    case ModalActionType.ShowPatientsManagement:
      return {
        medicalOperator: action.medicalOperator,
        operationVisible: ModalOperation.ManagePatients,
      };
    default:
      return state;
  }
};
